import Api from "./api.service";

export default {
    getFilters: () => Api.get("/get-options-notification"),
    sendNotifications: (data) => Api.post("/send-push-notifications", data),
};
